import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { Typography } from '@libs/components';
import { AssetOriginEnum } from '@libs/backend-common';

import { useNavigationItemsGe, useTranslation } from 'src/hooks';
import { ROUTES } from 'src/constants/route';

import {
  NavItemIconWrapper,
  NavItemsWrapper,
  NavItemTitleWrapper,
  NavItemWrapper,
} from './styles';

type OperationsNavigationProps = {
  assetCode?: string;
  className?: string;
};
const OperationsNavigation: React.FC<OperationsNavigationProps> = ({
  assetCode,
  className,
}) => {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const navItems = useNavigationItemsGe({
    color: colors.interactive.brandColor,
  });

  const navigate = useNavigate();

  const crypto = AssetOriginEnum.CRYPTO.toLowerCase();

  return (
    <NavItemsWrapper className={className}>
      {navItems.map((item, index) => {
        let path = `${item.route}/${assetCode}`;

        if (item.route === ROUTES.WITHDRAW || item.route === ROUTES.DEPOSIT) {
          path = `${item.route}/${crypto}/${assetCode}`;
        } else if (item.route === ROUTES.CONVERT) {
          path = `${item.route}/${crypto}/?fromAsset=${assetCode}`;
        }

        const handleClick = () => {
          navigate(path);
        };

        return (
          <NavItemWrapper
            key={index}
            onClick={handleClick}
            className="nav-item-wrapper"
          >
            <NavItemIconWrapper>{item.icon}</NavItemIconWrapper>
            <NavItemTitleWrapper>
              <Typography type="caption" fontFamily="primaryMedium">
                {t(item.title)}
              </Typography>
            </NavItemTitleWrapper>
          </NavItemWrapper>
        );
      })}
    </NavItemsWrapper>
  );
};

export default OperationsNavigation;
